module.exports = "/app/themes/roboyo2021/dist/img/chat-bk.png?c645ea1813861c454b841e9f4c5f3053";